// 印地语
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: 'उधार मुद्रा',
        Bo2: 'आपको और अधिक व्यापार अवसरों और वित्तीय उत्पादों का अन्वेषण करने में सहायता करें',
        Bo3: 'उधार मुद्रा के नियम',
        Bo4: 'यदि',
        Bo5: 'दिनों के भीतर लौटाएं: निश्चित ब्याज दर है',
        Bo6: 'अवधि समाप्त होने पर दैनिक बकाया राशि पर चार्ज किए जाएंगे',
        Bo7: 'जुर्माना। कृपया उधार लेने से पहले लौटाने की क्षमता पर ध्यान दें, ताकि अनावश्यक अतिरिक्त लागत से बचा जा सके।',
        Bo8: 'रद्द करें',
        Bo9: 'पुष्टि करें',
        Bo10: 'लौटाना',
        Bo11: 'ध्यान दें: जमा पता और लौटाने का पता भिन्न है, गलतियों से बचने के लिए सुनिश्चित करें कि आप सही लौटाने के पते पर मुद्रा लौटा रहे हैं।',
        Bo12: 'वॉलेट पता:',
        Bo13: 'संशोधन के लिए अस्वीकार करें',
        Bo14: 'अस्वीकृति का कारण:',
        Bo15: 'संपादित करना जारी रखें',
        Bo16: 'सबमिट सफल, संबंधित व्यक्ति 24 घंटे के भीतर आपके उधार मुद्रा आवेदन की समीक्षा करेगा, कृपया ध्यान दें',
        Bo17: 'स्वीकृत - जारी की गई सीमा',
        Bo18: 'आप क्रिप्टो खाता में देख सकते हैं',
        Bo19: 'उधार लिए गए दिन',
        Bo20: 'भुगतान',
        Bo21: 'ब्याज सहित',
        Bo22: 'एक-क्लिक भुगतान',
        Bo23: 'उधार मुद्रा की जानकारी',
        Bo24: 'बैंक का नाम',
        Bo25: 'बैंक खाता संख्या',
        Bo26: 'उधार मुद्रा की इच्छित राशि',
        Bo27: 'व्यक्तिगत पहचान प्रमाण',
        Bo28: 'पहचान पत्र का सामने और पीछे',
        Bo29: 'अपलोड पर क्लिक करें',
        Bo30: 'नाम',
        Bo31: 'सामान्य मोबाइल नंबर',
        Bo32: 'पहचान पत्र संख्या',
        Bo33: 'स्थायी पता',
        Bo34: 'वर्तमान निवास का पता',
        Bo35: 'गारंटर जानकारी प्रमाण',
        Bo36: 'गारंटर का नाम',
        Bo37: 'संपर्क नंबर',
        Bo38: 'ग्राहक के साथ संबंध',
        Bo39: 'निवास का पता',
        Bo40: 'आय प्रमाण (संकेत: वेतन स्टेटमेंट, कंपनी प्रमाण आदि अपलोड करें)',
        Bo41: 'आय प्रमाण',
        Bo42: 'संपत्ति प्रमाण (भूमि प्रमाण, वाहन प्रमाण, जमा प्रमाण)',
        Bo43: 'संपत्ति प्रमाण',
        Bo44: 'अन्य दस्तावेज़',
        Bo45: 'उधार मुद्रा के दस्तावेज़ सबमिट करें',
        Bo46: 'कृपया पहचान पत्र का सामने और पीछे अपलोड करें',
        Bo47: 'कृपया आय प्रमाण अपलोड करें',
        Bo48: 'कृपया संपत्ति प्रमाण अपलोड करें',
        Bo49: 'उपयोगकर्ता उधार मुद्रा',
        Bo50: 'रिपेमेंट सूची',
        Bo51: 'मुद्रा उधार लेना जोखिम भरा है, अंतिम परिणाम वास्तविक समीक्षा पर आधारित है',
        Bo52: 'मुद्रा उधार लेने का कारण क्या है?',
        Bo53: 'त्वरित स्वीकृति, पारदर्शी शुल्क',
        Bo54: 'कृपया उस बैंक का चयन करें जिससे आप मुद्रा उधार लेना चाहते हैं',
        Bo55: 'बैंक द्वारा सीधे ऋण, बिना किसी गिरवी के',
        Bo56: 'ऐतिहासिक',
        Bo57: 'मेमनोटिक कथन',
        Bo58: 'मेमनोटिक कथन ऐप पर लॉगिन करने के लिए उपयोग किया जा सकता है',
        Bo59: 'उत्पन्न करें',
        Bo60: 'देखें',
        Bo61: 'कॉपी करें',
        Bo62: 'बहुत दुख है',
        Bo63: 'हार मत मानो, रणनीति को समायोजित करें और फिर से कोशिश करें!',
        Bo64: 'बधाई हो',
        Bo65: 'शुभ augur! स्थिति बनाए रखें और और अधिक सफलता प्राप्त करें',
        Bo66: 'आर्डर देना जारी रखें',
        Bo67: 'आपकी धनराशि की सुरक्षा सुनिश्चित करने के लिए, कृपया निम्नलिखित प्रतिपादन सावधानियों पर विशेष ध्यान दें:',
        Bo68: '1. केवल प्लेटफॉर्म द्वारा प्रदान की गई आधिकारिक प्रतिपादन पता का उपयोग करें: प्लेटफॉर्म के आधिकारिक चैनलों के अलावा किसी भी स्रोत से प्राप्त किया गया प्रतिपादन पता अमान्य है।',
        Bo69: '2. धोखाधड़ी से सावधान रहें: यदि कोई व्यक्ति आपको निजी रूप से संपर्क करता है और एक मान्यता प्राप्त प्रतिपादन पता प्रदान करता है, तो इस पर आसानी से विश्वास न करें।',
        Bo70: '3. धनराशि सुरक्षा की जिम्मेदारी: यदि गलत प्रतिपादन पता के उपयोग के कारण धनराशि की हानि होती है, तो प्लेटफॉर्म उत्तरदायी नहीं होगा और कानून के अनुसार संबंधित कानूनी दायित्वों का पीछा कर सकता है।',
        Bo71: 'कृपया सतर्क रहें और प्रतिपादन क्रियाओं को औपचारिक चैनलों से सुनिश्चित करें ताकि आपकी संपत्ति की सुरक्षा को प्रभावी रूप से संरक्षित किया जा सके!',
        Bo72: 'सुरक्षा सूचना',
        Bo73: 'समझ गया',
        Bo74: 'आपका वर्तमान खाता एक आभासी खाता है, और खाते में सभी धन केवल सिमुलेटेड ट्रेडिंग के लिए हैं और वास्तविक निकासी क्रियाओं के लिए उपयोग नहीं किया जा सकता है। कृपया सतर्क रहें और संबंधित जोखिमों से बचें!',


    },
    Purchase: {
        Pu1: 'खरीद करो',
        Pu2: 'पैसा चुनें',
        Pu3: 'पैसा पद्धति चुनें',
        Pu4: 'क्रम पुष्टि करें',
        Pu5: 'आया',
        Pu6: 'बैलेंस',
        Pu7: 'कृपया क्रीप्त मात्रा भरें',
        Pu8: 'कृपया मात्रा भरें',
        Pu9: 'कृपया विक्रिया मात्रा भरें',
        Pu10: 'पूरा',
        Pu11: 'न्यूनतम से कम नहीं है',
        Pu12: 'अधिकतम से बड़ा नहीं है',
        Pu13: 'सूचनात्मक मूल्य',
        Pu14: 'मुक्त',
        Pu15: 'अब खरीद करो',
        Pu16: 'अब बेचो',
        Pu17: 'खरीद करें',
        Pu18: 'बेचो',
        Pu19: 'पैसा पद्धति चुनें',
        Pu20: 'पैमेंट पद्धति',
        Pu21: 'पैआउट पद्धति जोड़ें',
        Pu22: 'जोड़ें',
        Pu23: 'उपयोक्ता नाम',
        Pu24: 'बैंक कार्ड क्रमांक',
        Pu25: 'IFSC कोड',
        Pu26: 'फोन',
        Pu27: 'पुष्टि करें',
        Pu28: 'क्रम पुष्टि करें',
        Pu29: 'हाँ!',
        Pu30: 'आप सफलतापूर्वक हटाएँगे',
        Pu31: 'स्थिति',
        Pu32: 'पूर्ण',
        Pu33: 'प्राप्त मात्रा',
        Pu34: 'खरीदी',
        Pu35: 'बेचो',
        Pu36: 'मुद्रा नाम',
        Pu37: 'कुल ट्रांसेक्शन मात्रा',
        Pu38: 'मात्रा',
        Pu39: 'प्राय',
        Pu40: 'स्थिति',
        Pu41: 'समय',
        Pu42: 'प्राय',
        Pu43: 'सफल',
        Pu44: 'असफल',
        Pu45: 'प्रक्रिया कर रहा है',
        Pu46: 'मियाद समाप्त',
        Pu47: 'अस्वीकार',
        Pu48: 'से',
        Pu49: 'आधिकारिक वेबसाइट',
        Pu50: 'सफेद कागज',
        Pu51: 'परिचय',
        Pu52: 'आधिकारिक वेबसाइट लिंक',
    },
    nhome: {
        Nh1: 'दुनिया में सबसे बड़ा क्रिप्टोवेलेंसी परिवर्तन में से एक है',
        Nh2: 'प्लेटफ़ॉर्म पर एक मिलियन से अधिक रेजिस्ट्रेड प्रयोक्ताओं को प्राप्त करने के लिए, १००००००००० यूएसडीटी से अधिक रोजिस्ट्रेडिंग आव',
        Nh3: 'ट्रेडिंग आवाज',
        Nh4: 'उपयोक्ता',
        Nh5: 'विविध उत्पादन और सेवा',
        Nh6: '- अधिक सेवा चुनें और अन्तिम संभाव्यों को खोजें',
        Nh7: 'फुटरस ट्रेडिंग',
        Nh8: 'स्पोट ट्रेडिंग',
        Nh9: 'विकल्प ट्रेडिंग',
        Nh10: 'नियमित मुद्रा ट्रांसेक्शन्स',
        Nh11: 'सबसे उच्च फ्लोर्स दर, सबसे निम्न क्रम दर, उच्च प्रकार के साथ नया उच्च गुणस्तर मुद्रा प्रोजेक्ट्स के प्रकार।',
        Nh12: 'उच्च गुणवत्ता मुद्रा ट्रेडिंग सेवा सुरक्षित और विश्वासी सेवा के सौंडों को प्रदान करें, बाजार के ट्रांसेक्',
        Nh13: 'सहभागियों की सबसे बड़ी संख्या, साधारण खेल, उच्च संभावना',
        Nh14: 'एक-क्लिक तीव्र मुद्रा खरीद करने के लिए आपको एक प्रभावी और सुसंगत राल-टाइम ट्रेडिंग सिस्टम से प्रदान करता ह तुम्हारे पैसे सेकण्डों में आ सकते हैं।',
        Nh15: 'मार्केट ट्रेंड',
        Nh16: 'अधिक',
        Nh17: 'हमारे लाभ है',
        Nh18: 'दुनिया के ऊपर सुरक्षा जीवित नियंत्रण सिस्टम',
        Nh19: 'उपयोक्ता के सारे राउन्ड सुरक्षा',
        Nh20: '--- यह तुम्हारा विश्वासित प्लेटफ़ॉर्म है',
        Nh21: 'ऑफलाइन भण्डार मोड',
        Nh22: 'मल्टी- फैक्टर एनक्रिप्शन',
        Nh23: '24*7 दिन प्लेटफ़ॉर्म मॉनिटरिंग',
        Nh24: 'एक नेतृत डिजिटल आसेट ट्रेडिंग प्लेटफ़ॉर्म',
        Nh25: '—- बढ़ती डिजिटल मालिक व्यापार और मालिक प्रबंधन सेवाओं को विविध व्यापार की आवश्यकता पूरा करने के ल',
        Nh26: 'कहीं भी भी व्यापार प्रारंभ करें, कहीं भी',
        Nh27: 'आईओएस और एन्ड्रोइड सिस्टम के लिए पूरा समर्थन।',
        Nh28: 'डाउनलोड करने के लिए QR कोड स्कैन करें',
        Nh29: 'बढ़ने का चार्ट',
        Nh30: 'सूची अस्वीकार करें',
        Nh31: 'ट्रांसेक्शन आवाज सूची',
        Nu32: 'ग्लोबल प्रमुख डिजिटल आसेट ट्रेडिंग प्लेटफ़ॉर्म',
        Nu33: '- विविध व्यापार की आवश्यकता पूर्ण करने के लिए रिक्त डिजिटल मालिक व्यापार और मालिक प्रबंधन सेवा',
        Nu34: 'व्यापार आरंभ करें और सबसे अच्छा क्रिप्टोवेन्सी यात्रा अनुभव करें',
        Nu35: 'न्यूनतम लम्बाई 5 से कम नहीं होना चाहिए',
        Nu36: 'शीघ्र सोनी खरीद करते हैं',
        Nu37: 'कोन्ड खरीद करो',
        Nu38: '1 300W-1 बिल आईडीआर की एक ट्रांसेक्शन',
        Nu39: '2. पैसा खाता प्राप्त होने के बाद, कृपया निर्दिष्ट समय के अंदर स्थानान्तरण को पूरा करें. यदि यह निर्दिष्ट समय से अधिक होता है, कृपय',
        Nu40: 'ट्रांसफ़रेंस पूर्ण करने के बाद, कृपया ट्रांसकेशन खाता या खाता UID को प्रदान करें, और विस्तृत स्क्रीनशॉट और वैध व्',
        Nu41: 'जानने के लिए क्लिक करें'
    },
    common: {
        logins: 'लॉगिंग कर रहा है...',
        login: 'लागइन',
        register: 'हस्ताक्षर करें',
        loginregister: "लागइन/रेजिस्टर",
        logout: 'लॉग आउट',
        tip: 'टिप्प',
        logintip: 'पहले लॉग इन करें',
        expect: 'अपेक्षा की आशा करो!',
        delete: 'क्या तुम मिटाने के लिए पुष्टि करते हो?',
        nodata: 'कोई डाटा नहीं',
        set: 'Set',
        update: 'परिवर्धित',
        slogan: "दुनिया के ऊपर 50 डिजिटल मुद्रा बदलें",
        subslogan: "राज्य एजेंसिटी सुरक्षा को गारंट करती है",
        more: "अधिक",
        please: "कृपया",
        nodata: "कोई रिकार्ड नहीं",
        pleaseselect: "चुनें",
        searchplaceholder: "कोइन चिन्ह दाखिल करें...",
        searchplaceholderswap: "स्वेप चिह्न भरें...",
        loading: "लोड ...",
        close: "बन्द करें",
        ok: "ठीक है",
        fillComplete: "कृपया पूरी जानकारी भरें"
    },
    header: {
        index: 'घर',
        otc: 'OTC',
        exchange: 'बदलें',
        xiaoxi: 'संदेश',
        kefu: 'मदद',
        login: 'लागइन',
        register: 'रेजिस्टर',
        asset: 'एसेट',
        otcOrder: 'क्रम',
        ucenter: 'खाता',
        service: 'व्याख्या',
        downloadapp: "डाउनलोड और संस्थापन के लिए कोड स्कैन करें",
        appdownlaod: 'अनुप्रयोग डाउनलोड करें',
        usercenter: "प्रयोक्ता केंद्र",
        helpcenter: "मदद केंद्र",
        aboutus: "के बारेमें",
        partner: "साझेदार",
        bzb: "BZB ECO",
        assetmanage: "छोड़ें",
        trademanage: "बदलें",
        activity: "प्रकाश",
        lab: "BIPPAX लेब",
        ctc: "C2C बदलें",
        labdetail: "BIPPAX प्रकाश लेब",
        invite: "प्रोमोटिंग साझेदार",
        whitepaper: "सफेद कागज",
        scandownload: "अनुप्रयोग डाउनलोड करें",
        innovationmanage: "आवृत्ति",
        swap1: "स्वैप",
        swap2: "स्वैप(Ex)",
        swap3: "CFD",
        swap4: "सेकंड",
        cexchange: "क्विक एक्सचेंज",
        option: "विकल्प कंट्राक्ट",
        news: "समाचार"
    },
    sectionPage: {
        ptaqTitle: 'प्लेटफॉर्म सुरक्षा',
        ptaqContent: "हैश अल्गोरिदम दुनिया के प्रमुख सुरक्षा प्रमाणीकरण को एनक्रिप्ट करने के लिए इस्तेमाल किया जाता है",
        ptslTitle: 'प्लेटफॉर्म शक्ति',
        ptslContent: "दुनिया की सबसे बड़ी बिटकोइन ट्रेडिंग प्लेटफ़ॉर्म",
        newsTitle: 'समाचार केंद्र',
        brandTitle: "के बारेमें BIPPAX",
        brandDetail: "सच्चा  |  सामान्य  |  एन्टुसियाजम  |  खोलें",
        brandDesc1: "BIPPAX प्रारंभिक बिटकोइन सहभागियों और गीकों के एक समूह द्वारा स्थापित किया गया।. टीम के मुख्य सदस्य जैसे गूगल जानते हैं, माइक्रोसाफ्ट, अलिबाबा, टेन्सेंट और इससे भी. इसके पास इंटरनेट प्रोडेक्ट ऑपरेशन में गहिरा अनुशोधन और विकास शक्ति और धनी अनुभव है.",
        brandDesc2: "BIPPAX ब्लॉक चैन के मूल सेवा प्रदायक में स्थित है, वैश्विक उपयोक्ताओं के लिए उच्च गुणवत्ता एनक्रिप्टेड इज़टेडिंग प्लेटफ़ॉर्म प्रदान करन, “सामान्य नहीं हो जाओ” के मूलभूत प्राधान्य के अनुसार, सच्चाई का पालन करते हैं, ग्राहकों के लिए स्वीकार और उत्साहित सेवा, और सभी साझीदारी/प्रोजेक्टों को प्रारंभ करते हैं, जो खुली दृष्टि से उपयोक्ताओं के आधारिक रूप से उपयोक.",
        gettingstart: "गरम | प्रारंभक मार्गदर्शक है",
        officialstart: "BIPPAX आधिकारिक ग्राहक सेवा",
        oneminutebuy: "मुद्रा ट्रांसेक्शन",
        oneminutebuytips: "एक डिजिटल आसेट को दूसरे के लिए सीधे बदलने के लिए इस्तेमाल करें",
        baseknow: "संपर्क ट्रांसेक्शन",
        baseknowtips: "T+0 दो तरीके आभासी वस्तुओं को बार्टर कंट्रांट के रूप में व्यापार करते हैं",
        baseexchange: "विकल्प कंट्राक्ट",
        baseexchangetips: "क्या डिजिटल एक्स डिरिवेटिव हैं",
        usersocial: "छिटी एक्सचेंज",
        usersocialtips: "डिजिटल सामग्री",
        mainboard: "मुख्य बोर्ड",
        preview: "पछिला",
        nextpage: "अगला",
        downloadwhite: "सफेद कागज डाउनलोड करें"
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: 'पसंदीदा',
        COIN: 'कोइन',
        symbol: 'ट्रेडिंग जोड़ा',
        favor: 'पसंदीदा',
        NewPrice: "अंतिम",
        ExchangeNum: 'मात्रा',
        Change: 'बदलें',
        OpenPrice: 'खुला प्राइस',
        PriceTrend: 'प्राइस ट्रेंड',
        Operate: 'आपरेट',
        Exchange: 'एक्सचेंज',
        trading: "एक्सचेंज",
        high: "उच्च",
        low: "नीचे"
    },
    swapAssets: {
        Br1: 'प्रतिक्रिया खरीद करें',

        Br2: 'सदस्यता में खरीद करें',

        Br3: 'कंट्रैक्ट खाता में स्थानान्तरण करें',

        Br4: 'कंट्रैक्ट खाता से बाहर स्थानान्तरण करें',

        Br5: 'सदैव कन्ट्राक्ट्स के प्रोफिट और घाटा',

        Br6: 'अंत',

        Br7: 'संपर्क खाता (U मानक)',

        Br8: 'वालेट मात्रा',

        Br9: 'मौजूदा मूल्य',

        Br10: 'अधिक खोलें',

        Br11: 'हवा खोलें',

        Br12: 'अन्य कंट्रांक छुपाएँ',

        Br13: 'एक क्लिक बन्द स्थिति',

        Br14: 'सभी आदेश रद्द करें',
        Br15: 'सदैव कंट्रैक्ट सुधार',
    },
    exchange: {
        wholehog: 'पूरा हॉग',
        coin: 'कोइन',
        symbol: 'ट्रांसेक्शन जोड़ा',
        lastprice: 'अंतिम',
        daychange: 'बदलें',
        market: 'मार्केट्स',
        favorite: 'चिह्नित',
        do_favorite: 'संग्रहित',
        cancel_favorite: 'रद्द करें संग्रहित',
        type: "प्रकार",
        dealamount: "मात्रा समाप्त करें",
        high: 'उच्च',
        low: 'कम',
        vol: '24 घंटा रील',
        buy: 'खरीद करें',
        sell: 'बेचें',
        limited_price: 'सीमित मूल्य',
        market_price: 'मार्केट प्रायास',
        fees_rate: 'फीड दर',
        balance: 'मापक',
        or: 'और',
        starttrade: 'व्यापार अब!',
        canuse: 'उपलब्ध',
        recharge: 'डिपोस्ट',
        buyprice: 'मूल्य खरीद करें',
        buynum: 'मात्रा खरीद करें',
        amount: 'मात्रा',
        buyin: 'खरीद करें',
        disablebuyin: "मार्केट खरीद अक्षम",
        buytip: 'ऑप्टीमेटिम खरीद करें',
        sellprice: 'मूल्य बेचें',
        sellnum: 'मात्रा बेचें',
        sellout: 'बेचें',
        disablesellout: "मार्केट विक्रेत अक्षम",
        selltip: 'अनुकूल बेचें',
        curdelegation: 'प्रतिनिधि',
        hisdelegation: 'इतिहास प्रतिनिधि',
        realtransaction: 'मार्केट ट्रेड',
        num: 'मात्रा',
        price: 'मूल्य',
        direction: 'दिशा',
        time: 'समय',
        stall: 'स्थापित',
        total: 'कुल',
        traded: 'समाप्त',
        action: 'क्रिया',
        undo: 'वापस करें',
        delegationnum: 'प्रतिनिधित्व मात्रा',
        done: 'समाप्त',
        status: 'स्थिति',
        finished: 'पूरा हुआ',
        canceled: 'रद्द किया',
        parted: "अलग हुआ",
        tip: 'टिप्प',
        buyamounttip: 'खरीद मात्रा भरें',
        buyamounttipwarning: 'मात्रा अधिक नहीं खरीद करें',
        success: 'सफलता प्रदान करें!',
        pricetip: 'खरीदा क्रिया में प्रविष्ट करें',
        pricetipwarning: 'मूल्य अधिक नहीं खरीदी',
        sellamounttip: 'विक्रेत मात्रा भरें',
        sellamounttipwarning: 'विक्रेत मात्रा कम',
        sellpricetip: 'विक्रेत क्रिया भरें',
        sellpricetipwarning: 'मूल्य नहीं बेचें',
        undotip: 'पुनरावृत्ति पुष्टि करें?',
        cancelsuccess: "क्रम सफलता रद्द करें",
        marketprice: 'बाजार क्राय',
        expand: {
            time: 'समय',
            price: 'मूल्य',
            amount: 'मात्रा',
            fee: 'फीड',
        },
        realtime: 'रियल समय',
        kline: "केलाइन",
        depth: "गहराई",
        publishstate0: "यह शुरू करने के लिए है. कृपया इंतजार करें...",
        publishstate1: "यह समाप्त होने के लिए है. कृपया इंतजार करें...",
        publishstate2: "कन्सोलिडेशन क्रम, कृपया इंतजार करें...",
        publishstate3: "कोन्सोलिडेशन समाप्त है, कृपया मुक्त व्यापार करें...",
        publishdetail: "अधिक विवरण",
        publishprice: "मूल्य",
        publishamount: "मात्रा",
        publishcounttxt0: "एवोल्यूशन पता पुस्तिका",
        publishcounttxt1: "बाद अंत करें",
        publishcounttxt2: "बाद मुक्त व्यापार",
        publishcounttxt3: "क्रिया समाप्त!",
        dateTimeDay: "D",
        dateTimeHour: "H",
        dateTimeMinutes: "M",
        dateTimeSeconds: "S",
        moredetail: "अधिक देखें"
    },
    swap: {
        Sw1: 'मार्जिन बढ़ाना',
        Sw2: 'सीमा कम करें',
        Sw3: 'बढ़ाना',
        Sw4: 'घटाओ',
        Swवी5: 'मार्जिन',
        Sw6: 'अधिकतम अनुमति दिया',
        Sw7: 'के पश्चात बलवान मूल्य है',
        Sw8: 'है के बाद लेवेरेज अनुपात',
        Sw10: 'कंट्रांट सीमा बढ़ाना',
        Sw11: 'कंट्रांट सीमा कम करें',
        Sw12: 'विवरण पाठ',
        Spsl1: 'वास्तविक ट्रिगरिंग समय',
        Spsl2: 'ट्रिगर्स की वास्तविक संख्या',
        Spsl3: 'वास्तविक ट्रिगरिंग दिशा',
        Spsl4: 'वास्तविक ट्रिगर क्रिया',
        contract: "संपर्क",
        swapindex: "SWAP",
        coin: 'कोइन',
        symbol: 'कोइन जोड़ा',
        volume: "आवाज",
        lastprice: 'अंतिम',
        daychange: 'बदलें',
        market: 'मार्केट्स',
        favorite: 'मार्केड',
        do_favorite: 'संग्रहित',
        cancel_favorite: 'रद्द करें',
        type: "प्रकार",
        dealamount: "मात्रा समाप्त करो",
        high: 'उच्च',
        low: 'कम',
        vol: '24 घंटा रील',
        buy: 'खरीद करें',
        sell: 'बेचें',
        limited_price: 'सीमित मूल्य',
        market_price: 'मार्केट प्रायास',
        spot_price: 'ट्रिगर मूल्य',
        fees_rate: 'फीड दर',
        balance: 'बाल्युस',
        or: 'या',
        starttrade: 'व्यापार अब!',
        canuse: 'उपलब्ध',
        recharge: 'डिपोस्ट',
        buyprice: 'क्रिया खरीदा',
        buynum: 'मात्रा खरीद करो',
        amount: 'Amount',
        buyin: 'खरीद करो',
        disablebuyin: "मार्केट क्रीपी अक्षम",
        buytip: 'अप्टीमम खरीदी',
        sellprice: 'पैसा बेचें',
        sellnum: 'मात्रा बेचो',
        sellout: 'Sell',
        disablesellout: "मार्केट विक्रेत अक्षम",
        selltip: 'अप्टीमेम विक्री',
        curdelegation: 'प्रतिनिधि',
        hisdelegation: 'इतिहास प्रतिनिधि',
        realtransaction: 'मार्केट ट्रेड',
        num: 'मात्रा',
        price: 'मूल्य',
        direction: 'दिशा',
        time: 'समय',
        stall: 'स्थापित',
        total: 'कुल',
        traded: 'समाप्त',
        action: 'क्रिया',
        undo: 'वापस करें',
        delegationnum: 'प्रतिनिधित्व मात्रा',
        done: 'समाप्त',
        status: 'स्थिति',
        finished: 'पूरा हुआ',
        canceled: 'रद्द किया',
        parted: "अलग हुआ",
        tip: 'टिप्प',
        buyamounttip: 'खरीद मात्रा भरें',
        buyamounttipwarning: 'मात्रा अधिक नहीं खरीद करें',
        success: 'सफलता प्रदान करें!',
        pricetip: 'खरीदा क्रिया में प्रविष्ट करें',
        pricetipwarning: 'मूल्य अधिक नहीं खरीदी',
        sellamounttip: 'विक्रेत मात्रा भरें',
        sellamounttipwarning: 'विक्रेत मात्रा कम',
        sellpricetip: 'विक्रेत क्रिया भरें',
        sellpricetipwarning: 'मूल्य नहीं बेचें',
        undotip: 'पुनरावृत्ति पुष्टि करें?',
        cancelsuccess: "क्रम सफलता रद्द करें",
        marketprice: 'बाजार क्राय',
        expand: {
            time: 'समय',
            price: 'मूल्य',
            amount: 'मात्रा',
            fee: 'फीड',
        },
        realtime: 'रियल समय',
        kline: "केलाइन",
        depth: "गहराई",
        open: "खोलें",
        close: "बन्द करो",
        latestdeal: "अन्तिम व्यवहार",
        myswapaccount: "मेरा स्वैप खाता",
        accountmode: "पैट्रेन",
        accountmargin: "लेवेरेज",
        accountquanyi: "बराबर",
        profitandloss: "अज्ञात P/L",
        principalAmount: "उपलब्ध. मार्जिन",
        positionAmount: "प्रयोग किया गया सीमा",
        frozenAmount: "जल्दी मार्जिन",
        principalRate: "मार्जिन रेटिओ",
        zijinhuazhuan: "ट्रांसफेर",
        up: "L",
        down: "S",
        canup: "अधिकतम. L",
        candown: "अधिकतम. S",
        cancloseup: "अधिकतम(S)",
        canclosedown: "अधिकतम(L)",
        openup: "लांबा खोलें",
        opendown: "छोटा खोलें",
        closeup: "छोटा बन्द करें",
        closedown: "लांबा बन्द करो",
        currentposition: "स्थितियाँ खोलें",
        assetsdetail: "प्रतिक्रिया",
        marginMode1: "स्थिर",
        marginMode2: "क्रॉस",
        modifyMarginModeTitle: "खाता सीमा मोड परिवर्धित करें",
        modifyLeverage: "लेवेरेज समायोजित करें",
        moredetail: "अधिक देखो",
        shareNumber: "खाता",
        entrustprice: "मूल्य",
        triggleprice: "ट्रिग्गर",
        openvolume: "बड़ा आवाज",
        closevolume: "छोटा आवाज",
        triggleplaceholder: "डिफ़ॉल्ट मूल्य बाजार है",
        marketpriceplaceholder: "उत्तम क्रीस से व्यापार करेगा",
        levmaxtip: "स्तर अधिकतम पर नहीं होना चाहिए",
        levmintip: "लेव्रेज नीचे नहीं होना चाहिए",
        marginModeSuccessTip: "सफलता परिवर्धित करें.",
        noenoughbalance: "अपर्याप्त बाकी जोड़ी जोड़ें",
        pleaseinputopenvolume: "आवाज 0 के ऊपर होना चाहिए",
        pleaseinputcorrectopenvolume: "कृपया सही भोल्यूम इनपुट करें",
        pleaseinputrightentrustprice: "प्लावेस इनपुट सही मूल्य",
        noenoughposition: "अपर्याप्त स्थिति",
        pleaseinputclosevolume: "आवाज 0 के ऊपर होना चाहिए",
        pleaseinputcorrectclosevolume: "कृपया सही भोल्यूम इनपुट करें",
        pos_Pl: "PL.",
        pos_Ratio: "PL अनुपात",
        pos_pos: "स्थिति",
        pos_canClose: "स्थिति खोलें",
        pos_openPrice: "मूल्य खोलें",
        pos_leverage: "लेवेरेज",
        pos_margin: "कर्स सीमा",
        pos_mRatio: "सीमा अनुपात",
        pos_cmRatio: "मेंटेन अनुपात",
        pos_long: "लंबा",
        pos_short: "छोटा",
        ent_entrustType: "खोलें/बन्द करें",
        ent_direction: "दिशा",
        ent_type: "प्रकार",
        ent_trigglePrice: "ट्रिगर मूल्य",
        ent_entrustPrice: "प्रविष्टि क्रमाण",
        ent_tradedPrice: "ट्रेडेड क्राया",
        ent_margin: "मार्जिन",
        ent_volume: "आवाज",
        ent_status: "स्थिति",
        ent_status1: "प्रविष्टि",
        ent_status2: "रद्द किया",
        ent_status3: "प्रविष्टि असफल",
        ent_status4: "ट्रेड",
        ent_statusblast: "ब्लास",
        ent_pl: "P/L",
        ent_fee: "फी",
        triggerpriceshouldbigger: "ट्रिगर क्रिया 0 के ऊपर होना चाहिए"
    },
    subscribe: {
        Su1: 'विवरण पृष्ठ',

        Su2: 'सदस्यता',

        Su3: 'नया मुद्रा सदस्यता',

        Su4: 'प्रारंभ करें',

        Su5: 'प्रगति में',

        Su6: 'जो बताया जाएगा',

        Su7: 'दूरी',

        Su8: 'प्रारंभ',

        Su9: 'इस्सुएन्स प्राप्ति',

        Su10: 'अपेक्षित लाभ और हराम अनुपात',

        Su11: 'शुरू समय',

        Su12: 'प्रकाशन समय',

        Su13: 'विवरण',

        Su14: 'सदस्यता',

        Su15: 'सबस्क्रिप्शन रेकॉर्ड',

        Su16: 'मुद्रा नाम',

        Su17: 'स्वागत क्यूल्य',

        Su18: 'स्वागत क्यूल्य',

        Su19: 'जीते हुए आदेशों की संख्या',

        Su20: 'पुनरावृत्ति मात्रा',

        Su21: 'समय',

        Su22: 'स्थिति',

        Su23: 'समय',

        Su24: 'सदस्यता मात्रा',

        Su25: 'सबस्क्रिप्शन मुद्रा',

        Su26: 'स्वागत क्रम',

        Su27: 'अपेक्षित लाभ और घाटा',

        Su28: 'सबस्क्रिप्शन सीमा',

        Su29: 'सबस्क्रिप्शन प्रारंभ समय',

        Su30: 'सबस्क्रिप्शन अंतिम समय',

        Su31: 'परिणाम प्रकाशन का समय',

        Su32: 'अपेक्षित लांच समय',

        Su33: 'सबस्क्रिप्शन मात्रा',

        Su34: 'मुद्रा',

        Su35: 'सबस्क्रिप्शन मात्रा',

        Su36: 'सबस्क्रिप्शन समय',

        Su37: 'स्थिति',

        Su38: 'बताया जाएगा',

        Su39: 'प्रकाशित',

        Su40: 'प्रोजेक्ट जानकारी',

        Su41: 'उपलब्ध बैलेंस',

        Su42: 'तुरंत लागू करो',

        Su43: 'सभी',

        Su44: 'पैमेंट पासवर्ड',

    },
    option: {
        minute: 'मिनट',
        enter: 'कृपया प्रविष्ट करें',
        title: "विकल्प विरोधी",
        buyupreward: "रीवार्ड पूल खरीद करें",
        buydownreward: "रीवार्ड पूल बेलें",
        quantity: "बेट मात्रा",
        myamount: "मेरी बेट मात्रा",
        buyup: "प्रायास अप",
        buydown: "क्राय नीचे",
        history: "इतिहास",
        seriers: "नहीं.",
        period: "",
        currentoption: "समय क्षेत्र",
        openprice: "मूल्य खोलें",
        currentprice: "मौजूदा मूल्य",
        openprice1: "मूल्य खोलें",
        closeprice: "मूल्य बन्द करें",
        opentime: "समय खोलें",
        closetime: "ऑफ समय",
        progress: "प्रगति",
        loginFirst: "कृपया पहले लागइन करें!",
        selectAmount: "कृपया अपनी मात्रा चुनें",
        balancenotenough: "बैन्लैंस काफी नहीं है!",
        betsuccess: "अभिनन्दन! सफलता पूरा!",
        noopening: "यह अब खुला नहीं है!",
        col_createTime: "समय बनाएँ",
        col_direction: "दिशा",
        col_result: "परिणाम",
        col_optionNo: "नहीं.",
        col_betAmount: "बेट मात्रा",
        col_rewardAmount: "मात्रा पुनरावृत्ति",
        col_fee: "फीज खोलें",
        col_winfee: "फिर फिर करें",
        win: "जीती",
        lose: "गुमाए",
        wait: "खोल रहा है",
        avaliablebalance: "उपलब्ध संतुलन",
        login: "कृपया लॉगिन करें",
        kline: "रियल समय उद्धरण",
        or1: 'हार्गा टर्किन',
        or2: 'मासा पेर्तारुहान',
        or3: 'जुम्ला पेर्तारुहान',
        or4: 'माता वांग पेर्तारुहान',
        or5: 'जुम्ला लेन',
        or6: 'हार्गा सेमासा आदाला हार्गा पेलाक्सानान',
        or7: 'व्यापार इतिहास',
        or8: 'ओड्ड',
        or9: 'बोनास',
        or10: ' रेकोद पेर्दागांगान',
        or11: 'सिला पिलिहा 4 जुम्ला पेर्टारुहान USDT यांग बियासा',
    },
    activity: {
        all: "सभी",
        prepare: "आने",
        ongoing: "चल रहे हैं",
        distributing: "वितरण",
        completed: "पूरा हुआ",
        progress: "प्रगति",
        totalsupply: "कुल संपूर्ण",
        starttime: "प्रारंभिक तारीख",
        endtime: "अंतिम तिथि",
        viewdetail: "विवरण",
        attend: "सहभागी",
        tokendistribute: "टोकन वितरण",
        baseinfo: "क्रिया जानकारी",
        status: "स्थिति",
        activitytype: "क्रिया प्रकार",
        activitytype0: "अनकनाउन",
        activitytype1: "सूची(FOF)",
        activitytype2: "सूची(AVA)",
        activitytype3: "होल्डर विभाजन",
        activitytype4: "फ्रीबुल",
        activitytype5: "मिनिंग ब्यू",
        activitytype6: "तालाबन्द",
        ruledetail: "नियमों के बारे में",
        publishprice: "प्रकाशन क्रिया",
        activitycoin: "क्रियाशीलता कोइन चिन्ह",
        accpetcoin: "कोइन चिन्ह स्वीकारें",
        holdcoin: "कोइन चिन्ह होल्ड करें",
        limittimes: "व्यक्तिगत सीमा टाइम्स",
        limitamount: "व्यक्तिगत सीमान्त मात्रा",
        unlimited: "बिना सीमा है",
        alreadyamount: "पहले ही मात्रा विक्रिया",
        leftamount: "बायाँ मात्रा",
        attention: "ध्यान",
        attentiontxt1: "1、[भण्डार पार्टीशनिंग] और [मुक्त सदस्यता] प्रकार क्रियाओं में सहभागी देने के लिए दाखल करने के बाद स्मृद्धि किया.",
        attentiontxt2: "2、प्रयोक्ताओं के प्रकार 'होल्डर विभाजित' और 'फ्रेस खरीदी' के क्रियाओं में सहभागी होने के बाद सहभागी के लिए अपने",
        attentiontxt3: "3、घटना रद्द किया जाता है जैसे प्रोजेक्ट पार्टी, मौलिक मार्ग जल्दी मालिकों में फिर दिया जाएगा.",
        attentiontxt4: "* Tवह इस क्रिया के अन्तिम अनुवाद का अधिकार BIPPAX के आधिकारिक मालिक है.",
        inputamount: "इनपुट मात्रा",
        inputholdamount: "इनपुट लाक मात्रा",
        mybalance: "उपलब्ध उपलब्ध",
        holdtips: "[होल्डर विभाजित] क्रिया के अन्त तक लॉकाउट की जरूरत है.",
        pleaseinputamount: "कृपया इनपुट मात्रा!",
        pleaseinputholdamount: "कृपया इनपुट मात्रा पकड़ें!",
        commitfailed: "कमिट असफल!",
        minlimitamountfailed: "बदलाव की मात्रा न्यूनतम बदलाव की मात्रा से कम नहीं होना चाहिए।!",
        maxlimitamountfailed: "परिवर्तन की मात्रा अधिकतम खरीदी मात्रा से अधिक नहीं होगी!",
        limittimesfailed: "आप व्यक्तिगत खरीदों की अधिकतम संख्या से अधिक सहभागी हैं!",
        balancenotenough: "बैलेंस काफी नहीं है!",
        headertitledesc: "विनजीन सहकारी के लिए लेबोरेटरी खोलें, प्रोजेक्टर और एक्सचेंज",
        currentdivided: "मेरा वर्तमान स्थिति प्राप्त होगा",
        leveloneCount: "स्तर एक गिनती सीमित करें",
        submit: "भेजें",
        tipsmobile: "कृपया पीसी वेब इस्तेमाल करें (www.BIPPAX.com)",
        tipsmobile1: "इस क्रियाकलाप के लिए आप पीसी वेब भर सकते हैं.",
        intvalue: "कृपया इन्ट मूल्य इनपुट करें",
        inputminingamount: "इनपुट खरीद गणना",
        moreactivity: "अधिक क्रियाएँ",
        releaseType: "निर्गत प्रकार",
        releaseType0: "समान मुक्ति",
        releaseType1: "आइजोमेट्रिक मुक्ति",
        lock: "ताला लगाएँ ",
        releaseDetail: "प्रदान के विवरण",
        lockday: " दिन",
        lockweek: " सप्ताह",
        lockmonth: " माह",
        lockyear: " साल",
        releasePercent: "प्रतिशत रिलिज़",
        lockFee: "ताला लगाएँ फी",
        releaseTimes: "निर्गत समय",
        times: "फिर"
    },
    uc: {
        verify: "समाप्त KYC पहिले",
        login: {
            noaccount: 'कोई खाता नहीं है?',
            register: 'रेजिस्टर',
            login: 'लॉगइन',
            welcomelogin: 'स्वागत',
            usertip: 'कृपया इमेल भरें',
            pwdtip: 'पासवर्ड भरें',
            validatecodeload: 'सत्यापन कोड लोड किया जा रहा है',
            validatemsg: 'कृपया पहिले सत्यापन समाप्त करें',
            forget: 'पासवर्ड भूलें?',
            loginvalidate: 'कृपया इमेल या फोन संख्या इनपुट करें',
            pwdvalidate1: 'कृपया पासवर्ड इनपुट करें',
            pwdvalidate2: 'पासवर्ड लंबाई छे से कम नहीं',
            success: 'सफलता',
            goregister: "रेज़िस्ट्रिस्ट करना",
            getlostpwd: "पासवर्ड भूलें"
        },
        forget: {
            title: "पासवर्ड ढूंढें",
            hasaccount: 'कोई खाता है?लगइन के लिए',
            login: 'लागइन',
            sendcode: 'भेजें',
            newpwd: 'नया पासवर्ड भरें',
            confirmpwd: 'फिर नया पासवर्ड भरें',
            save: 'भेजो',
            pwdvalidate1: 'पुष्टि पासवर्ड भरें',
            pwdvalidate2: 'पासवर्ड समान नहीं है!',
            resettelpwd: 'टेल पासवर्ड रिसेट करें',
            resetemailpwd: 'इमेल पासवर्ड रिसेट करें',
            newpwdtip: 'नया पासवर्ड भरें',
            pwdvalidate3: 'पासवर्ड लंबाई छे से कम नहीं',
            telno: 'टेल संख्या',
            mtelno: 'मोबाइल फोन प्रमाणीकरण',
            memail: 'मेलबाक्स प्रमाणीकरण',
            smscode: 'सत्यापित कोड स्म्स करता है',
            teltip: 'टेल भरें',
            smscodetip: 'एसएमस प्रमाणीकरण कोड भरें',
            email: 'ईमेल',
            emailcode: 'इमेल परीक्षण कोड',
            emailtip: 'ईमेल भरें',
            emailcodetip: 'ईमेल परीक्षण कोड भरें',
            resetpwdsuccess: 'पासवर्ड सफलता सेट करें',
            smswarn: 'कृपया SMS के लिए जाँचें',
        },
        finance: {
            fi1: 'छोटे गाय छुपाएँ',
            center: 'फैन्स केंद्र',
            personalassets: 'मुद्रा एसेट',
            swapassets: 'स्वाप एसेट',
            billdetail: 'बिल विवरण',
            charge: 'डिपोज़िट',
            pickup: 'विचर्वाल',
            tradetail: 'व्यापार मिनिंग',
            paydividends: 'पीडीविडेन्ड्स को पीड़ दो।',
            invitingmining: 'मिनिंग प्रतिज्ञा निमन्त्रणा किया जा रहा है',
            money: {
                M1: 'प्राप्त मात्रा',

                M2: 'मात्रा बाहर स्थानान्तरित करें',

                M3: 'एक्सचेंज दर',
                cointype: 'कोइन',
                balance: 'बाकी पैसा',
                frozen: 'जल्दी बैलेंस',
                operate: 'क्रिया',
                charge: 'डिपोज़िट',
                pickup: 'विचर्वाल',
                onkeytrans: "ट्रांस",
                getaddress: 'पता प्राप्त करें',
                resetsuccess: 'सफल रिसेट करें',
                match: 'मिलाना',
                matchtip1: 'उपलब्ध जीक्स मेल मात्रा',
                matchtip2: 'मेल मात्रा भरें',
                matcherr1: 'कृपया एक वैध मात्रा भरें!',
                matcherr2: 'मिलान की अधिकतम संख्या बढ़ती है!',
                matchsuccess: 'सफल मिलाना!',
                needreleased: "मुक्त होने के लिए आसान",
                totalassets: "एसेट के कुल मूल्य आनुमानित:"
            },
            swap: {
                totalassets: "एसेट के कुल मूल्य आनुमानित:",
                swap: " स्वैप",
                swaptype: 'SWAP',
                swapassets: "खाता इकाविटी",
                avabalance: "अवाली सीमा",
                usebalance: "प्रयोग किया गया सीमा",
                frozenbalance: "जल्दी सीमा",
                profitandloss: "अज्ञात प्ल",
                transfor: "ट्रांसफ़र",
                inputtransferamount: "स्थानान्तरण मात्रा",
                all: "सभी",
                currencyaccount: "खाता स्थान",
                swapaccount: "सदैव स्वेप खाता",
                clickchange: "दिशा बदलने के लिए क्लिक करें",
                avaamount: "उपलब्ध",
                pleaseselectwallet: "कृपया एक स्थानान्तरण वालेट फिस्ट चुनें.",
                pleaseinputamount: "कृपया स्थानान्तरण मात्रा इनपुट करें",
                oktransfer: "अब ट्रांसफ़रेंस्ट करें"
            },
            trade: {
                start_end: 'प्रारंभ - अंत',
                account_date: 'राजधानी प्राप्त करने के लिए समय',
                to: 'में',
                operatetype: 'क्रिया प्रकार',
                search: 'खोजें',
                charge: 'चार्ज',
                pickup: 'उठाओ',
                transaccount: 'ट्रांसफ़रेंस',
                exchange: 'बदलें',
                otcbuy: 'OTC-खरीद करें',
                otcsell: 'OTC-बेचें',
                activityaward: 'क्रियात्मक प्रतिज्ञ',
                promotionaward: 'प्रगति प्रतिज्ञा',
                dividend: 'विभाजन',
                vote: 'वोट',
                handrecharge: 'कलाकार पुनर्चार्ज',
                match: 'मिलाना',
                activitybuy: "क्रियाशीलता खरीदी",
                ctcbuy: "CTC-खरीद करें",
                ctcsell: "CTC-बेचें",
                chargetime: 'उत्पन्न समय क्रमबद्ध करें',
                type: 'प्रकार',
                num: 'मात्रा',
                status: 'स्थिति',
                finish: 'समाप्त',
                fee: 'मिनिंग फीज़ का वापस',
                transactionTime: 'ट्रेडिंग समय',
                symbol: 'कोइन जोड़ा',
                direction: 'दिशा',
                price: 'मूल्य',
                entrustment: 'प्रविष्टि',
                havedeal: 'एक व्यापार किया है',
                poundageAmount: 'सेवा चार्ज ',
                exchangeOrderId: "क्रम ID",
                mineAmount: "एक मुद्रा डिज़ (BHB)",
                buy: "BUY",
                sell: "SELL",
                limit: "LIMIT",
                market: "MARKET",
                clear: "परिस्थिति साफ करें",
                turnover: "परिवर्तन"
            },
            paydividende: {
                money_holding: 'पैसा साझेदारी लौटा दिया गया है और जमा किया गया है (ETH): ',
                money_hold: 'वापस होने के लिए डिविडेन्ड पैदा करें(ETH) : ',
                paydividends: 'विभाजन पैदा करें(ETH)',
                account_date: 'राजधानी प्राप्त करने के लिए समय',
                datehodld: 'पैसा पकड़ने का तिथि',
                start_end: 'प्रारंभ - अंत',
                to: 'में',
                operatetype: 'क्रिया प्रकार',
                search: 'खोजें',
                charge: 'चार्ज',
                pickup: 'उठाओ',
                transaccount: 'ट्रांसफ़रेंस',
                exchange: 'बदलें',
                otcbuy: 'OTC-खरीद करें',
                otcsell: 'OTC-बेचें',
                activityaward: 'क्रियात्मक प्रतिज्ञ',
                promotionaward: 'प्रगति प्रतिज्ञा',
                dividend: 'विभाजन',
                vote: 'वोट',
                handrecharge: 'कलाकार पुनर्चार्ज',
                match: 'मिलाना',
                chargetime: 'चार्ज समय',
                type: 'प्रकार',
                num: 'मात्रा',
                status: 'स्थिति',
                finish: 'समाप्त',
                fee: 'फीड',
                symbol: 'कोइन चिन्ह',
            },
            record: {
                Please: 'कृपया खोज तारीख सीमा चुनें',
                start_end: 'प्रारंभ - अंत',
                to: 'में',
                operatetype: 'क्रिया प्रकार',
                search: 'खोजें',
                charge: 'चार्ज',
                pickup: 'उठाओ',
                transaccount: 'स्थानान्तरण',
                exchange: 'बदलें',
                otcbuy: 'OTC-खरीद करें',
                otcsell: 'OTC-बेचें',
                activityaward: 'क्रियात्मक प्रतिज्ञ',
                promotionaward: 'प्रगति प्रतिज्ञा',
                dividend: 'विभाजन',
                vote: 'वोट',
                handrecharge: 'कलाकार पुनर्चार्ज',
                match: 'मिलाना',
                chargetime: 'चार्ज समय',
                type: 'प्रकार',
                num: 'मात्रा',
                status: 'स्थिति',
                finish: 'समाप्त',
                fee: 'फीड',
                shouldfee: 'भर देना चाहिए',
                revenue: 'आयुष्य और खर्च क़िस्म',
                re1: 'आइन्गांग',
                re2: 'आस्गांग',
                discountfee: 'डिड्यूक्शन चार्ज',
                realfee: 'सेवा चार्ज',
                symbol: 'कोइन चिन्ह',
                activitybuy: "क्रियाशीलता खरीदी",
                ctcbuy: "C2C खरीद करें",
                ctcsell: "C2C बेचें",
                redout: "RED-बाहर",
                redin: "RED-अंदर",
                quickExchange: "शीघ्र एक्सचेंज",
                currentRate: "वर्तमान एक्सचेंज दर",
                from: "From",
                inputexchangeamount: "इनपुट तुरंत एक्सचेन्ज मात्रा",
                inputexchangepasswd: "इनपुट एक्सचेन्ज पासवर्ड",
                chooseTransCoinUnit: "ट्रांस कोइन चुनें",
                inputTransAmount: "ट्रान्समॉन्ट चुनें",
                predictAmount: "विस्तारित होगा",
                qamount: "एमूट",
                qrate: "दर",
                qexamount: "एक्सचेंज मात्रा",
                withdrawcodein: "विचड्रैव कोड पुनरार्ज",
                withdrawcodeout: "विचड्रावेल कोड विचड्रावेल कोड",
                contractfee: "स्वैप फी",
                contractprofit: "प्रोफाइट स्वैप करें",
                contractloss: "हटाने को स्वाप करो",
                optionfail: "विकल्प असफल",
                optionfee: "विकल्प फी",
                optionreward: "विकल्प पुनरावृत्ति",
                other: "अन्य"
            },
            recharge: {
                recharge: 'डिपोस्ट',
                symbol: 'कोइन',
                address: 'डिपोस्ट पता',
                copy: 'नकल',
                qrcode: 'QR कोड',
                qrcodeaddress: 'QR कोड डिपोस्ट के लिए',
                msg1: 'उत्तम पता में किसी नॉन मुद्रा एसेट को फिर नहीं चार्ज करें, अन्यथा सामग्री पुनः प्राप्त नहीं किया जा सकता.',
                msg2: 'आप ऊपर के पता पर फिर चार्ज करें, आपको पूरा नेटवर्क नोड की पुष्टि करना होगा, 2 नेटवर्क पुष्टिकरण आने के बाद, 6 नेटवर्क पुष्टिकरण के बाद निकाला जा सकता है.',
                msg3: 'न्यूनतम पुनरार्ज मात्रा: ',
                msgtop: 'यह पता केवल जमा के लिए है',
                msg3_1: ", न्यूनतम मात्रा से कम पुनर्चार्ज नहीं किया जाएगा.",
                msg4: 'आपका टॉप- अप पता बहुत से बदला नहीं जाएगा और आप फिर चार्ज को दोहरा सकते हैं; यदि कोई परिवर्तन है, हम तुम्हें वेब संदेश या इमेल द्वारा सूचना करने की कोशिश करेंगे.',
                msg5: 'कृपया अपने कम्प्यूटर और ब्राउज़र की सुरक्षा को पुष्टि करने के लिए सुनिश्चित हो जाओ कि जानकारी को टैम्प्.',
                record: 'रेकार्डिंग',
                copysuccess: 'सफल!',
                copyerr: 'असफल! कृपया इसे मैनुअल प्रतिलिपि करें',
                time: 'आयात समय',
                amount: 'मात्रा',
                gettingaddress: "डेपोसिट पता प्राप्त कर रहा है, कृपया इंतजार करें...",
                getaddress: "डिपोसिट पता प्राप्त करें",
                memotips: "कृपया इस मेमो को पुनर्चार्ज करने के दौरान प्रविष्ट करें, अन्यथा तुम माल हराएँगे.",
                withdrawrecharge: "कोड के द्वारा फिर चार्ज करें",
                coderechargetip: "कृपया आंतरिक कोड भरें",
                rechargesuccess: "अभिनन्दन, पुनर्चार्ज सफलता है!",
                rechargeconfirm: "पुनर्चार्ज करके",
                status: "स्थिति"
            },
            withdraw: {
                pickup: 'उठाओ',
                addressmanager: 'पता प्रबंधन',
                withdrawbycode: 'कोड द्वारा हटाएँ',
                withdrawcode: 'विच्छेद्राव कोड',
                symbol: 'कोइन',
                address: 'पता',
                num: 'मात्रा',
                avabalance: 'बाकी पैसा का उपयोग करें',
                msg1: 'संख्या की मात्रा इससे कम है',
                msg2: 'खाता पर स्वचालित रूप से प्रवेश करें, अन्यथा मैनुअल पुनरावृत्ति जरूरी है',
                increase: 'क्रेडिट बढ़ाएँ',
                tip1: 'यहाँ प्रविष्ट करें',
                tip11: 'दशमलव स्थान और न्यूनतम मूल्य है',
                tip2: 'अधिकतम मूल्य है',
                numtip1: 'संख्या की संख्या भरें',
                fee: 'फीट',
                range: 'सीमा',
                arriamount: 'आवाजों की संख्या',
                msg3: 'न्यूनतम संख्या है',
                msg4: 'मुद्रा',
                msg5: 'फंड की सुरक्षा सुरक्षित करने के लिए, जब आपका खाता सुरक्षा पालिसी बदलें, पासवर्ड बदले गए हैं, और आप नया पता में संकेत ले सकते हैं, हम संख्याओं के एक मैनुअल ऑडिट का प्रयोग करेंगे. कृपया धैर्य हो और स्टेबल को कॉल या इमेल के लिए इंतजार करें.',
                msg6: 'कृपया अपने कम्प्यूटर और ब्राउज़र की सुरक्षा को पुष्टि करने के लिए सुनिश्चित हो जाओ कि जानकारी को टैम्प्.',
                record: 'वाटवाल रेकॉर्ड',
                symboltip: 'कृपया एक मुद्रा चुनें',
                addresstip: 'कृपया पता भरें',
                numtip2: 'कृपया संख्या की सही संख्या भरें, न्यूनतम मूल्य है',
                numtip3: 'कोनेज मात्रा प्रोसेसिंग फीस से कम नहीं होना चाहिए',
                amounttip: 'कृपया मात्रा भरें',
                feetip1: 'न्यूनतम फीज है',
                feetip2: 'अधिकतम मूल्य है',
                time: 'हटाने का समय',
                status: 'स्थिति',
                status_1: 'पुनरावृत्ति',
                status_2: 'स्थानान्तरण',
                status_3: 'असफल',
                status_4: 'सफल',
                St5: 'आनमानिक शक्तिशाली पैरिटी',
                St6: 'कुल आसात = वालेट उपलब्ध पैसा + अवैध',
                St7: 'अज्ञात लाभ और हराम = अज्ञात लाभ और गुमावट की गणना है सभी कंट्राक्ट के लिए अन्तिम मूल्य के प्रयोग से अन्तिम मूल्य',
                St8: 'वालेट उपलब्ध पैसा = स्थानांतरित करें - रोल आउट - वास्तविक प्राप्त और हराम',
                St9: 'अस्वीकारित',
                remark: 'रिमार्क',
                add: 'जोड़ें',
                addresslist: 'पता सूची',
                safevalidate: 'सुरक्षा परीक्षण',
                telno: 'फोन',
                mtelno: 'मोबाइल फोन प्रमाणीकरण',
                memail: 'मेलबाक्स प्रमाणीकरण',
                smscode: 'टेलिफोन परीक्षण कोड',
                second: 'सेकंड',
                clickget: 'प्राप्त करें',
                email: 'इलेक्ट्रोनिक मेल',
                emailcode: 'इलेक्ट्रोनिक मेल  सत्यापन कोड',
                save: 'सहेजें',
                delete: 'मिटाएँ',
                telerr: 'गलत फोन संख्या',
                emailerr: 'गलत इमेल',
                codeerr: 'सत्यापन कोड त्रुटि',
                remarktip: 'टिप्पणी भरें',
                savemsg1: 'सहेजने में असफल!',
                savemsg2: 'सफलतापूर्वक सहेजा गया!',
                operate: 'आपरेट करें',
                fundpwdtip: 'कृपया फ़ंड्स पासवर्ड भरें',
                click: 'क्लिक करें',
                filtrate: 'फिल्टरेट कर सकता है',
                txid: "TxId",
                generateCode: "वाइडर्रैव कोड उत्पन्न करें",
                withdrawcodelist: "WithdrawCode List",
                withdrawcodestatus: "स्थिति",
                submit: "भेजें",
                generatecodesuccess: "उत्पन्न कोड उत्पन्न हुआ!",
                wi1: 'नेटवर्क',
                wi2: 'सुरक्षा प्रमाणीकरण',
                wi3: 'आगमन मात्रा',
                wi4: 'आगमन पता',
                wi5: 'पैसे नेटवर्क',
                wi6: 'पैसा के कुल मात्रा',
                wi7: 'नेटवर्क चार्ज',
                wi8: 'कृपया सुनिश्चित करो कि आप सही प्रतिलिपि पता प्रविष्ट किया है और कि आप चुने हुए प्रतिलिपि नेटवर्क को पता के साथ मि',
                wi9: ' बनाने के पश्चात रिक्रेशन क्रम रद्द नहीं किया जा सकता.',
                wi10: 'जारी रखो',
                wi11: 'आर्थिक पासवर्ड',
                wi12: 'मोबाइल फोन परीक्षण कोड',
                wi13: 'भेजें',
                wi14: 'ईमेल परीक्षण कोड',
                wi15: 'भेजें',
                wi16: 'भेजो',

            }
        },
        member: {
            usercenter: "उपयोक्ता प्रोफाइल",
            securitycenter: 'सुरक्षा केंद्र',
            securitysetting: 'सुरक्षा सेटिंग',
            accountsetting: 'खाता सेटिंग',
            account: "खाता",
            assets: "छोड़ें",
            exchange: "बदलें",
            curdelegate: "मौजूदा प्रतिनिधि",
            hisdelegate: "इतिहास प्रतिनिधि",
            otc: "OTC"
        },
        regist: {
            Res1: 'उपयोक्ता नाम खाली नहीं हो सकता, अक्षरों और छोटे अक्षरों और संख्या के समाविष्ट है, और अक्षरों को समाविष्ट करना चा',
            hasaccount: 'कोई खाता है? लॉग इन करने के लिए',
            login: 'लागइन',
            username: 'उपयोक्ता नाम',
            country: 'देश',
            smscode: 'सत्यापित कोड स्म्स करता है',
            sendcode: 'भेजें',
            resendcode: "रिसान्ड(",
            pwd: 'पासवर्ड',
            repwd: 'पासवर्ड पुष्टि करें',
            confrimpwd: 'कॉन्फ्रेम कूटशब्द',
            agreement: 'मैंने पढ़या है और स्वीकार किया है',
            userprotocol: 'उपयोक्ता स्वीकार',
            regist: 'रेजिस्टर',
            teltip: 'टेल भरें',
            telerr: 'फ़ॉर्मेट त्रुटि टेल करें, फिर प्रविष्ट करें',
            emailtip: 'ईमेल भरें',
            emailerr: 'ईमेल प्रारूप त्रुटि, फिर प्रविष्ट करें',
            confirmpwdtip: 'पुष्टिप्त पासवर्ड भरें',
            confirmpwderr: 'दो पासवर्ड एक ही नहीं!',
            telregist: 'टेल रेजिस्ट्री',
            emailregist: 'ईमेल रेजिस्ट',
            usernametip: 'प्रयोक्ता नाम भरें',
            usernamemsg: 'उपयोक्ता नाम लंबाई 3 से कम नहीं, 15 से अधिक नहीं',
            countrytip: 'देश चुनें',
            smscodetip: 'एसएमस प्रमाणीकरण कोड भरें',
            pwdtip: 'लॉगइन पासवर्ड भरें',
            pwdmsg: 'पासवर्ड लंबाई 6 से कम नहीं',
            telno: 'टेल्नो',
            email: 'इमेल',
            agreementtip: 'सहमत करने के लिए क्लिक करें',
            modaltitle: 'कृपया सत्यापित करें',
            promotion: 'कोड आमन्त्रित करो',
            china: 'चीना',
            singapore: 'सिंगापुर',
            korea: 'कोरिया',
            japan: 'जापान',
            thailand: 'थाइलैंड',
            russia: 'रूसिया',
            uk: 'uk',
            vietnam: 'विएतनाम',
            india: 'इंडिया',
            italy: 'इटाली',
            hk: 'hk',
            malaysia: 'मलेशिया',
            taiwan: 'टाइवान',
            turkey: 'टर्की',
            germany: 'जर्मनी',
            france: 'फ्रांस',
            spain: 'स्पेन',
            us: 'अमेरिकन',
        },
        safe: {
            beneficiaryTitle: 'लाभार्थी जानकारी',
            beneficiaryEmpty: 'लाभार्थी की जानकारी अभी सेट नहीं की गई है',
            beneficiaryName: 'लाभार्थी का नाम',
            beneficiaryIdNumber: 'लाभार्थी का पहचान संख्या',
            beneficiaryMobilePhone: 'लाभार्थी का मोबाइल नंबर',
            beneficiaryNamePlaceholder: 'कृपया लाभार्थी का नाम दर्ज करें',
            beneficiaryIdPlaceholder: 'कृपया लाभार्थी का पहचान संख्या दर्ज करें',
            beneficiaryMobilePlaceholder: 'कृपया लाभार्थी का मोबाइल नंबर दर्ज करें',
            beneficiaryTip: 'लाभार्थी का नाम, पहचान संख्या और मोबाइल नंबर दर्ज करने और संशोधित करने के लिए उपयोग किया जाता है।',
            beneficiaryNameRequired: 'कृपया लाभार्थी का नाम दर्ज करें',
            beneficiaryNameInvalid: 'लाभार्थी का नाम 2 से 30 अक्षरों के बीच होना चाहिए',
            beneficiaryIdRequired: 'कृपया लाभार्थी का पहचान संख्या दर्ज करें',
            beneficiaryIdInvalid: 'लाभार्थी के पहचान संख्या का प्रारूप अमान्य है',
            beneficiaryMobileRequired: 'कृपया लाभार्थी का मोबाइल नंबर दर्ज करें',
            beneficiaryMobileInvalid: 'लाभार्थी के मोबाइल नंबर का प्रारूप अमान्य है',
            Ad1: 'कृपया अपने सामाजिक सुरक्षा कार्ड, ड्राइवर की लाइसेंस, या पासपोर्ट अपलोड करें',
            Ad2: 'प्रेषित करने से पहले फ़ाइलों में से एक को अपलोड करें',
            Ad3: 'पूरा नाम',
            Ad4: 'संपर्क पता',
            Ad5: 'जीवित स्ट्रीमिंग',
            Ad6: 'मेरा जीवित है',
            Ad7: 'जोड़ने विफल, अधिकतम 3 को जोड़ सकता है',
            size: 'अपलोड किया गया छवि का आकार 5M से बढ़ नहीं सकता',
            safelevel_low: 'सुरक्षा स्तर: कम',
            safelevel_high: 'सुरक्षा स्तर: उच्च',
            safelevel_medium: 'सुरक्षा स्तर: मध्यम',
            nickname: 'उपनाम',
            bind: 'बाइन्ड',
            binded: 'बाइन्डेड',
            verifypass: "सत्यापित",
            binding: 'बाइन्डिंग',
            binderr: 'असफल',
            bindretry: 'फिर कोशिश करें',
            verified: 'सत्यापित',
            notverified: "सत्यापित नहीं",
            verifiedtip: 'अपने खाता सुरक्षा को सुरक्षित करने के लिए, कृपया वास्तविक नाम प्रमाणपत्र पूरा करें इससे पहले कि आप आप',
            realname: 'वास्तविक नाम',
            idcard: 'आईडी कार्ड',
            upload: 'अपलोड करें',
            upload_positive: 'फोटो आईडी आगे अपलोड करें',
            upload_negative: 'अपने आईडी कार्ड के बैक फोटो को अपलोड करें',
            upload_hand: 'आईडी कार्ड को पकड़ने के लिए फोटो अपलोड करें',
            save: 'सहेजें',
            reset: 'रिसेट करें',
            email: 'इमेल',
            bindemail: 'बाइन्ड इमेल',
            loginpwd: 'लॉगइन पासवर्ड',
            emailcode: 'इमेल परीक्षण कोड',
            clickget: 'प्राप्त करने के लिए क्लिक करें',
            second: 's',
            phone: 'टेलिफोन',
            bindphone: 'बाइन्ड फोन',
            phonecode: 'टेलफोन परीक्षण कोड',
            logintip: 'प्लेटफ़ॉर्म पर लॉगिंग करने के लिए इस्तेमाल करें',
            edit: 'परिवर्धित करें',
            oldpwd: 'पुराना लॉगइन पासवर्ड',
            newpwd: 'नया लॉगइन पासवर्ड',
            confirmnewpwd: 'नया पासवर्ड यकीन करें',
            fundpwd: 'फ़ंड पासवर्ड',
            fundtip: 'जब खाता फ़ंड बदलेंगे, तुम्हें पहले फ़ंड के पासवर्ड परीक्षा करने की जरूरत है',
            set: 'सेट',
            confirmpwd: 'पासवर्ड पुष्टि करें',
            oldfundpwd: 'पुराना फंड पासवर्ड',
            newfundpwd: 'नया फंड पासवर्ड',
            newpwdmsg1: 'कृपया 6 नया लॉगइन पासवर्ड से कम नहीं भरें',
            newpwdmsg2: 'नया लॉगइन पासवर्ड संस्थित नहीं है',
            pwdmsg1: 'कृपया 6 पासवर्ड से कम नहीं भरें',
            pwdmsg2: 'पासवर्ड असंगतता',
            emailtip: 'कृपया इमेल भरें',
            codetip: 'कृपया सत्यापन कोड भरें',
            telnotip: 'कृपया फोन संख्या भरें',
            oldpwdtip: 'कृपया मूल पासवर्ड भरें',
            realnametip: 'कृपया अपना वास्तविक नाम भरें',
            idcardtip: 'कृपया आईडी संख्या भरें',
            bindphonetip: 'पहले अपना फोन बाइंड करें!',
            resetfundpwd: 'प्रतिस्थापन फंड PIN',
            upload_positivetip: 'कृपया फोटो आईडी कार्ड आगे अपलोड करें',
            upload_negativetip: 'कृपया फोटो आईडी कार्ड उलटा अपलोड करें',
            upload_handtip: 'कृपया हैंडहेल्ड आईडी फोटो अपलोड करें',
            save_success: 'सफल!',
            save_failure: 'असफल!',
            imgtip: 'प्राप्त करनेवाले के लिए कृपया अपना QR कोड अपलोड करें',
            idcard_verifymsg1: "1. फ़ाइल आकार 8 मेगाबी से छोटा है. फ़ाइल की जानकारी स्पष्ट दृश्य होनी चाहिए, दस्तावेज में कोई परिवर्तन या विदेशी वस्तुओं के द्वारा कवर की अनुमति नहीं है, और दस्तावेज़ संख्या और नाम दृश्यात्मक होना चाहिए.",
            idcard_verifymsg2: "2. फोटोग्राफ तुम्हें एक टोपी के बिना दिखाना चाहिए. यह सिफारिस किया जाता है कि कोई मेकअप नहीं है.. हाथ हेल्ड दस्तावेज़ हॉल्डर के चेहरे विशेषता साफ होना चाहिए, और हाथों को पूरी तरह प्रदर्शन होना चाहिए.",
            idcard_verifymsg3: "3. हाथ हेल्ड दस्तावेज़ और हैंडलिखित कॉपी होने की जरूरत है (नाम + अनुप्रयोग तारीख), 'इस साइट में मेरे सभी कार्य मेरे आपरेशन हैं, और मुझे इस खाते के सभी व्यवस्था परिणाम के लिए जोखियों को समझ लेता है.'"
        },
        otcorder: {
            money: 'पैसा',
        },

        extension: {
            currrecharge: 'ट्रांसेक्शन',
        },
        promotion: {
            exchange: "बदलें",
        },
    },
    cms: {
        noticecenter: 'व्याख्या केंद्र',
        newshelp: 'नया उपयोक्ता मदद कर रहा है',
        appdownload: 'डाउनलोड APP',
        onlineservice: 'ऑनलाइन सेवा',
        faq: 'क्यू एंड ए',
        notice: 'प्रस्तुति',
        servicecenter: 'मनपसंद केंद्र',
        about: 'के बारेमें',
        joinus: 'हमारे साथ जोड़ें',
        aboutus: 'हमारे विषय में',
        exchangerule: 'ट्रेडिंग नियम',
        useprotocol: 'एमेंट्रिंग इस्तेमाल करें',
        feenote: 'चार्ज वर्णन',
        merchantprocotol: 'व्यापारिक सहभागी',
        features: "विशेषता",
        contactus: "हमसे संपर्क",
        noticelist: 'सभी प्रस्तुति',
        nextnotice: 'NEXT',
        prevnotice: "PREV",
        notexist: "जो पृष्ठ आप ने भेजा है वह मौजूद नहीं है या मिटाया गया है",
        otherhelp: "इस श्रेणी में अन्य",
        scanforshare: "साझेदार के लिए स्कैन करें",
        download: "डाउनलोड",
        downloadslogan: "BIPPAX APP - हर जगह व्यापार."
    },
    description: {
        title1: 'सुरक्षा',
        title2: '24H सेवा',
        title3: 'वैश्विक एक्सचेंज',
        title4: 'रिगोरोस प्रोजेक्ट',
        message1: 'सभी आर्थिक वायु नियंत्रण सिस्टम तथा चोरी सिस्टम, गरम और थंडी वालीट, पैसा की सुरक्षा सुरक्षित करने के लिए बहुत-हस्ताक्षर सिस्टम',
        message2: '24H मैनुअल ऑनलाइन ऑडिट के लिए ग्राहकों को सबसे अच्छी निवेश संभावना पर गुम होने से बचा सकता है.',
        message3: 'व्यापारिक क्रिप्टो मालिकों में निवेश करने के लिए व्यापारिक सेवा के व्यापारिक नेटवर्क की मदद करें',
        message4: 'हम उन उच्च गुणवत्ता ब्लॉकचेन प्रोजेक्टों को चुनेंगे कि तुम्हारे लिए 80% अत्यंत उच्च जोखित प्रोजेक्ट.',
        scanqrcode: "APP डाउनलोड करें",
        aboutdesc1: "BIPPAX. प्रोग्राम दुनिया में एक प्रमुख डिजिटल आसेट ट्रेडिंग प्लेटफ़ॉर्म है, कैमन द्वीप में रेजिस्टरिज किया गया, हांग कांग में एक कोर ऑपरेटिंग टीम के साथ. BIPPAX.PRO के मुख्य सदस्य उप्पर इंटरनेट और आर्थिक कंपनियों से आते हैं. उनमें से बहुतेरे लोग बिटकोन और ब्लॉकेन्स में सच्चे हैं. हमने विश्वास किया है कि ब्लॉक संख्या पारंपरिक मोनोपोलिसिक आर्थिक तंत्र परिवर्तन करेंगे और एक अधिक लोकशास्त्री.",
        aboutdesc2: "BIPPAX.PRO प्लेटफ़ॉर्म के पास एक प्रोफेशनल आर्थिक स्तर व्यापारित आर्किटेक्टिंग स्थापना है, एक स्वयं विकास उच्च संयुक्त मेमोरी मिलाने वाली इंजिन. प्लेटफ़ॉर्म पूरा थंडा पुनर्चार्जेबल वालेट सिस्टम इस्तेमाल करता है + बहुत हस्ताक्षर + ग्राहक सुरक्षा सुरक्षित करने के लिए उच्च सुरक्षा डीडोस हटाने वाला सिस्टम और अन्य व्यापारित आर्कि.",
        aboutdesc3: "ग्राहकों को बेहतर निवेश संभावनाओं को समझने के लिए, BIPPAX.PRO ग्राहक सेवा विभाग में फ्लैट प्रबंधन को स्वीकार करता है, और एक अत्यंत तेज सेवा प्रतिक्रिया यंत्रिया स्थापित करता है. ग्राहक ग्राहक सेवा प्रबंधक सभी वर्ष के राउण्ड 7*24H है, जहाँ ग्राहकों को सेवा के साथ पुनर्चार्ज और मालिक के पैसे प्रदान करते हैं, और सुनिश.",
        aboutdesc4: "BIPPAX.PRO स्क्रीन होस्टिंग सेवा सुरक्षित और स्थिर होस्टिंग सेवा प्रदान करता है. BIPPAX.PRO “सच्चाई, न्याय, उत्साह और खुलापन का विचार पालन करता है”, और प्रयोक्ताओं के लिए सुरक्षित, विश्वासित, प्रभावित और मित्र अन्तिम बदलाने के लिए प्रयास करता है.",
        aboutdesc5: "हालाँकि डिजिटल सामान्य अब सिर्फ छोटे वृत्त में हैं, हम विश्वास करते हैं कि इस प्रकार के मालिकों को जिन्होंने भविष्य में पूरी तरह प्राप्त कर सकते हैं. चलो एक साथ काम करें और इसके आगे आगे राखें!",
        support: "समर्थन",
        report: "सुझाव",
        service: "पसंदीदा सेवा",
        apply: "बोर्ड लागू करें",
        coop: "सहयोग",
        community: "BIPPAX समुदाय",
        wechat: "वेचैट",
        addwechat: "'coinex' को वेचैट दोस्तों के रूप में जोड़ें और फिर वेचैट समुदाय में प्रविष्ट करें",
        weibo: "माइक्रो- ब्लॉग",
        twitter: "ट्विटर",
        biyong: "Biyong",
        telegram: "टेलिग्राफ",
        medium: "मध्यम",
        reddit: "Reddit"
    },
    footer: {
        wechatkefu: "वीचैट सेवा",
        notice: 'प्रस्तुति',
        gsmc: 'सबसे अच्छा क्रिप्टोकुरेंट बदलें',
        bah: 'नहीं. 13026899 - 3, शांघाई आईसीपी',
        gsjj: 'प्रोफाइल',
        gywm: 'हमारे बारे में।',
        jrwm: 'हमारे साथ जोड़ो।',
        biyong: 'Biyong',
        lxwm: 'हमें संपर्क करो',
        yqlj: 'लिंक',
        bzzx: 'मदद',
        xsrm: " एक प्रारंभिक कोर्स",
        czzn: 'मार्गदर्शिका फिर चार्ज करो',
        jyzn: 'व्यापार मार्गदर्शन',
        ptsm: 'स्पष्ट करो',
        fysm: 'फीस',
        fwtk: 'सेवा पालिसी',
        fltk: 'व्यवस्था पालिसी',
        wechat: "वेचैट क्यास्टयर सेवा",
        xszn: "प्रारंभिक मार्गदर्शिका",
        cjwt: "क्यू एंड ए",
        mztk: "डिस्क्लेमर",
        ystk: "निजी नीति",
        tkxy: "परिस्थिति",
        gybzb: "के बारेमें BZB",
        kfyx: "सेवा मेलबाक्स",
        swhz: "सहयोग",
        sbsq: "मार्केट अनुप्रयोग",
        jyzn: "एक्सचेन्ज मार्गदर्शन",
        bzzl: "कोइन जानकारी",
        tsjb: "रिपोर्ट",
        apidoc: "एपी डॉक",
        zwkf: "जल्दी आओ"
    },
    index: {
        circulation: 'सुरक्षा और विकास फंड सर्क्लेशन',
        hourEth: 'आज में वितरित होने के लिए कुमुलेटिव आगत',
        yesterdayEth: 'कल में वितरित होने के लिए कुमुलेटिव आगत',
        yesterday: 'पहले दिन का मिनिम आउटपुट किया जा रहा है:',
        bhbTotal: "BHB कुल फ्लॉक्स",
        bhbSecond: "BHB दो स्तर मार्केट सर्क्लेशन",
        checkMineprinciple: "मिनिंग का प्रिन्सिप्ट देखें",
        checkFlowVolum: 'सर्क्लेशन की निरीक्षण',
        checkLockPosition: 'तालाबंद स्थिति जाँचें',
        BHBregister: "BIPPAX खाता रिजिस्ट्रेशन",
        tibi: "पैसा के पैसा का पैसा का समय और सीमा बिल्ल पर",
        line_plane: "बीहीबी के ऑनलाइन प्लान, सर्क्लेशन तथा सेवा फीज लौटाने के बारे में व्याख्या",
        fenpeijizhi: 'बीपीपीएक्स आगत वितरण यंत्राधिकार का वर्णन',
        jiangli_jihua: "मिनिंग इंकेंटिव प्रोग्राम में सहभागी करने के लिए आमन्त्रित करें",
        friend_fanhuan: "दोस्तों को आमन्त्रित करो, अतिरिक्त फीज़ ले आओ और वापस आओ"
    },
    home: {
        login: {
            title: 'ट्रैडिंग क्रिप्टोकरन्स प्रारंभ करें',
            desc: '500+ क्रिप्टोवेरेंसी और विविध ट्रेडिंग औजार की समर्थन',
            btnText: 'व्यापार अब'
        },
        unlogin: {
            title: 'डिजिटल परिसंपत्तियों के साथ अपनी यात्रा शुरू करें',
            desc: 'रजिस्टर करें और नए उपयोगकर्ता उपहार पैकेज का आनंद लें।',
            placinfo: 'फ़ोन/ईमेल',
            btnText: 'रजिस्टर'
        },
        WelfareCenter: 'कल्याण केंद्र',
        Welcome_ceremony: 'नया उपयोगकर्ता उपहार',
        Airdrop: 'ऐयरड्रॉप',
        DailyGain: 'दैनिक पुरस्कार',
        AirdropGift: 'एयरड्रॉप उपहार',
        financial_management: 'अनुकूलित वित्तीय प्रबंधन',
        Zhoude: 'साप्ताहिक पुरस्कार',
        height_is: 'अच्छा',
        Happiness: 'भाग्य का कार्निवल',
        Monthly: 'मासिक पुरस्कार',
        CarveUp: 'पुरस्कार पूल',
        download: {
            transactions_anytime: 'किसी भी समय, कहीं भी व्यापार करें',
            scan_code: 'डाउनलोड करने के लिए स्कैन करें',
            download_more: 'अधिक डाउनलोड करें'
        },
        brand: {
            digital_platform: 'अग्रणी डिजिटल परिसंपत्ति व्यापार मंच',
            rich_digital: 'विविध कारोबारी जरूरतों को पूरा करने के लिए समृद्ध डिजिटल एसेट ट्रेडिंग और परिसंपत्ति प्रबंधन सेवाएं',
            High_quality_digital: 'उच्च गुणवत्ता वाले डिजिटल संपत्ति',
            Turnover: 'खरीदी बिक्री दर',
            safety_risk: 'विश्व स्तरीय सुरक्षा और जोखिम प्रबंधन प्रणाली',
            multi_factor: 'ऑफ़लाइन भंडारण, बहुकारक एन्क्रिप्शन, 24/7 मंच की निगरानी, उपयोगकर्ता संपत्ति सुरक्षा की व्यापक सुरक्षा',
            Security_reserve: 'प्रतिभूति आरक्षित निधि',
            accident: '9 वर्षों में 0 दुर्घटनाएं',
            safetyrisk: 'शीर्ष स्तर की सुरक्षा और जोखिम नियंत्रण',
            choice_trusted: 'पसंद है लाखों उपयोगकर्ताओं द्वारा',
            transaction_service: 'दुनिया भर के अनेक देशों और क्षेत्रों में स्थानीयकृत लेनदेन सेवा केन्द्रों की स्थापना, अनेक व्यापार रूपों के साथ एक ब्लॉकचेन पारिस्थितिकी तंत्र का निर्माण',
            ten_thousand: 'दस हजार',
            User_preference: 'उपयोगकर्ताओं द्वारा पसंदीदा',
            Countries_covered: 'आच्छादित देश'
        },
        trading: {
            digital_currency: 'डिजिटल एसेट से आपका जार्नी प्रारंभ करें',
            register: 'रेजिस्टर',
            login: 'लागइन',
            currency_transaction: 'ट्रैडिंग क्रिप्टोकरन्स प्रारंभ करें',
            to_trade: 'व्यापार अब'
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/in/index.js